// eslint-disable-next-line no-unused-vars
import React, { useCallback, useEffect, useState } from 'react';
import {
  callAPIHelperV2,
  DisplayWarningMessage, // eslint-disable-line no-unused-vars
  getClonedDefaultSettingsV2,
  resetTableDataV2,
  updatedTableDataForPreferenceV2,
  callFxgApi,
} from 'axp-fx-common';
import { useSelector } from 'react-redux';
import { apiPaths } from '../../../constants/paths';
import { contactsDirectoryProp } from './contactInformationItnitData';
import {
  API_SUCCESS_CD,
  CERT_ERROR_CD,
  PROD_ERROR_CD,
} from '../../../constants/apiCodes';
// eslint-disable-next-line no-unused-vars
import EnhancedDataTableWrapper from '../../Common/EnhancedDataTableWrapper';

const defaultTableSettings = getClonedDefaultSettingsV2(contactsDirectoryProp);

const ContactInformationExternalDirectory = () => {
 const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const [errorData, setErrorData] = useState([]);
  const [tableData, setTableData] = useState(contactsDirectoryProp);

  const fetchData = async () => {
    setErrorData([]);
    const { response, hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.getContacts}`,
      'GET',
      ''
    );
    let newRows = { totalRows: 0, data: [] };
    /* istanbul ignore else */
    if (!hasErrors) {
      if (response?.respCd === API_SUCCESS_CD && response.data?.length > 0) {
        const rowData = [];
        response.data?.forEach((row) => {
          const rowMap = row;
          rowMap.rowId = `${row.userEmailId}_${row.digitalAssetGroup}_${row.environment}`;
          rowMap.showActions = row.hasUpdateAccess;
          rowData.push(rowMap);
        });

        newRows = {
          totalRows: rowData.length,
          data: rowData,
        };
      }

      if ([CERT_ERROR_CD, PROD_ERROR_CD].includes(response?.respCd)) {
        setErrorData([response?.respMsg]);
      }
    }
    return { newRows, hasErrors };
  };

  const loadTableData = useCallback(async (updatedTableData) => {
    const { newRows, hasErrors } = await fetchData(updatedTableData);
    callAPIHelperV2(updatedTableData, newRows, setTableData, hasErrors);
  }, []); // fetchData is stable

  useEffect(() => {
    if (loginData?.userDetail?.emailAddress) {
    updatedTableDataForPreferenceV2(tableData, loginData);
    resetTableDataV2(tableData);
    loadTableData(tableData);
    }
  }, [loadTableData, loginData]); // tableData is mutable

  // const onActionItemClick = (actionId) => {
  //   const selectedRow = getSelectedRowsV2(tableData)?.[0];
  //   if (!selectedRow) return;
  //   setSelectedContact(selectedRow);
  //   if (actionId === 'update_contact') {
  //     setStepNo(2);
  //   }
  // };

  return (
    <>
      {errorData?.length > 0 && (
        <DisplayWarningMessage messageDataList={errorData} />
      )}

      <EnhancedDataTableWrapper
        tableData={tableData}
        setTableData={setTableData}
        fetchTableData={fetchData}
        // onItemActionClick={onActionItemClick}
        defaultTableSettings={defaultTableSettings}
      />
    </>
  );
};

export default ContactInformationExternalDirectory;
